import { parseCookies } from '@cian/utils';

import {
  FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY,
  FOREVER_REGION_ID_COOKIE_KEY,
  SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY,
  SESSION_REGION_ID_COOKIE_KEY,
} from '../../../../constants/geoSwitcher';

export function getRegionIdFromCookie(): number | null {
  const cookies = parseCookies(document.cookie);
  const sessionMainTownRegionId = parseInt(cookies[SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY], 10);
  const foreverMainTownRegionId = parseInt(cookies[FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY], 10);
  const sessionRegionId = parseInt(cookies[SESSION_REGION_ID_COOKIE_KEY], 10);
  const foreverRegionId = parseInt(cookies[FOREVER_REGION_ID_COOKIE_KEY], 10);
  const regionId = sessionMainTownRegionId || foreverMainTownRegionId || sessionRegionId || foreverRegionId;

  if (!Number.isFinite(regionId)) {
    return null;
  }

  return Math.abs(regionId);
}
